import React, { useState } from 'react';
import { HeartIcon } from 'lucide-react';
import Modal from './Modal';
const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="w-full py-8 bg-[#3a3a3a] text-white" data-id="element-98">
        <div className="container mx-auto px-4" data-id="element-99">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-100">
            <div className="mb-4 md:mb-0" data-id="element-101">
              <h2 className="text-xl font-serif font-medium" data-id="element-102">Belleza Latina</h2>
              <p className="text-sm text-gray-300" data-id="element-103">
                La guía de belleza para mujeres latinas
              </p>
            </div>
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-104">
              <button onClick={() => setShowTerms(true)} className="text-sm hover:text-[#f8e9e6] transition" data-id="element-105">
                Términos y condiciones
              </button>
              <button onClick={() => setShowPrivacy(true)} className="text-sm hover:text-[#f8e9e6] transition" data-id="element-106">
                Política de privacidad
              </button>
            </div>
          </div>
          <div className="mt-8 pt-6 border-t border-gray-700 text-center" data-id="element-107">
            <p className="text-sm text-gray-300 flex items-center justify-center gap-2" data-id="element-108">
              Hecho con <HeartIcon size={14} className="text-[#b76e79]" data-id="element-109" /> para
              todas las mujeres latinas
            </p>
            <p className="text-xs text-gray-400 mt-2" data-id="element-110">
              © {new Date().getFullYear()} Belleza Latina. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-111">
        <div className="space-y-4 text-[#3a3a3a]" data-id="element-112">
          <p className="text-sm text-[#5a5a5a]" data-id="element-113">
            Última actualización: {new Date().getFullYear()}
          </p>
          <div data-id="element-114">
            <h3 className="font-medium text-lg mb-2" data-id="element-115">
              1. Aceptación de los términos
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-116">
              Al adquirir y utilizar la guía "Belleza Latina", aceptas estos
              términos y condiciones en su totalidad.
            </p>
          </div>
          <div data-id="element-117">
            <h3 className="font-medium text-lg mb-2" data-id="element-118">2. Uso del producto</h3>
            <p className="text-[#5a5a5a]" data-id="element-119">
              Este producto digital es para uso personal únicamente. No está
              permitida la redistribución, reventa o compartir el contenido sin
              autorización expresa.
            </p>
          </div>
          <div data-id="element-120">
            <h3 className="font-medium text-lg mb-2" data-id="element-121">
              3. Propiedad intelectual
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-122">
              Todo el contenido, incluyendo textos, imágenes y diseños, está
              protegido por derechos de autor y pertenece a Belleza Latina.
            </p>
          </div>
          <div data-id="element-123">
            <h3 className="font-medium text-lg mb-2" data-id="element-124">
              4. Garantía de satisfacción
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-125">
              Ofrecemos una garantía de satisfacción de 30 días. Si no estás
              satisfecha con tu compra, puedes solicitar un reembolso completo
              dentro de este período.
            </p>
          </div>
          <div data-id="element-126">
            <h3 className="font-medium text-lg mb-2" data-id="element-127">
              5. Limitación de responsabilidad
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-128">
              Los resultados pueden variar según cada persona. La información
              proporcionada es de carácter educativo y no sustituye el consejo
              médico profesional.
            </p>
          </div>
        </div>
      </Modal>
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-129">
        <div className="space-y-4 text-[#3a3a3a]" data-id="element-130">
          <p className="text-sm text-[#5a5a5a]" data-id="element-131">
            Última actualización: {new Date().getFullYear()}
          </p>
          <div data-id="element-132">
            <h3 className="font-medium text-lg mb-2" data-id="element-133">
              1. Información que recopilamos
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-134">
              Recopilamos información básica necesaria para procesar tu compra,
              incluyendo nombre, correo electrónico y datos de pago (procesados
              de forma segura por nuestros proveedores).
            </p>
          </div>
          <div data-id="element-135">
            <h3 className="font-medium text-lg mb-2" data-id="element-136">
              2. Uso de la información
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-137">
              Utilizamos tu información únicamente para:
            </p>
            <ul className="list-disc list-inside text-[#5a5a5a] mt-2 space-y-1" data-id="element-138">
              <li data-id="element-139">Procesar y entregar tu compra</li>
              <li data-id="element-140">Enviar actualizaciones sobre tu pedido</li>
              <li data-id="element-141">Proporcionar soporte al cliente</li>
              <li data-id="element-142">Mejorar nuestros productos y servicios</li>
            </ul>
          </div>
          <div data-id="element-143">
            <h3 className="font-medium text-lg mb-2" data-id="element-144">3. Protección de datos</h3>
            <p className="text-[#5a5a5a]" data-id="element-145">
              Implementamos medidas de seguridad para proteger tu información
              personal. No vendemos ni compartimos tus datos con terceros sin tu
              consentimiento.
            </p>
          </div>
          <div data-id="element-146">
            <h3 className="font-medium text-lg mb-2" data-id="element-147">4. Cookies</h3>
            <p className="text-[#5a5a5a]" data-id="element-148">
              Utilizamos cookies para mejorar tu experiencia de navegación y
              analizar el tráfico del sitio web.
            </p>
          </div>
          <div data-id="element-149">
            <h3 className="font-medium text-lg mb-2" data-id="element-150">5. Tus derechos</h3>
            <p className="text-[#5a5a5a]" data-id="element-151">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal en cualquier momento. Contáctanos para ejercer estos
              derechos.
            </p>
          </div>
          <div data-id="element-152">
            <h3 className="font-medium text-lg mb-2" data-id="element-153">
              6. Cambios en la política
            </h3>
            <p className="text-[#5a5a5a]" data-id="element-154">
              Nos reservamos el derecho de actualizar esta política de
              privacidad. Los cambios se publicarán en esta página.
            </p>
          </div>
        </div>
      </Modal>
    </>;
};
export default Footer;